import React, { useState } from "react";
import BaseModal from "../../modal/BaseModal";
import TableDetail from "./TableDetail";

const SubmittedDataTable = ({ data }) => {
    const [clickedRow, setClickedRow] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    if (!Array.isArray(data) || data.length === 0) {
        return <p>No data found</p>;
    }

    // Convert "fields.name" → "Name"
    const formatHeader = (key) => {
        const last = key.split(".").pop();
        return last.charAt(0).toUpperCase() + last.slice(1);
    };

    // Keys you want to hide
    const hiddenKeys = ["_id","id", "user_id", "createdat", "updatedat", "status", "__v"];

    // Extract keys while preserving natural appearance order
    const extractKeys = (obj, parent = "") => {
        let keys = [];

        for (let key of Object.keys(obj)) {
            const value = obj[key];
            const fullKey = parent ? `${parent}.${key}` : key;

            const lastKey = fullKey.split(".").pop().toLowerCase();
            if (hiddenKeys.includes(lastKey)) continue;

            if (typeof value === "object" && value !== null && !Array.isArray(value)) {
                keys.push(...extractKeys(value, fullKey));
            } else {
                keys.push(fullKey);
            }
        }

        return keys;
    };

    // Build ordered columns
    let orderedColumns = [];

    data.forEach(row => {
        const keys = extractKeys(row);
        keys.forEach(k => {
            const lower = k.toLowerCase();
            if (!orderedColumns.some(col => col.toLowerCase() === lower)) {
                orderedColumns.push(k);
            }
        });
    });

    // Force fields.* first in correct sequence
    const fieldColumns = orderedColumns.filter(c => c.startsWith("fields."));
    const otherColumns = orderedColumns.filter(c => !c.startsWith("fields."));

    const allColumns = [...fieldColumns, ...otherColumns];

    // Get nested value safely
    const getValue = (obj, path) => {
        const parts = path.split(".");
        let result = obj;

        for (let part of parts) {
            if (result == null) return "";
            result = result[part];
        }
        return result ?? "";
    };

    const handleCloseModal = () => setIsModalOpen(false);

    const handleRowClick = (row) => {
        setIsModalOpen(true);
        setClickedRow(
            <TableDetail
                inline={true}
                columns={{ lg: 9, xl: 7 }}
                data={{ fields: row.fields }}
            />
        );
    };

    return (
        <>
            <div className="table-responsive">
                <table className="table table-hover">
                    <thead>
                    <tr>
                        {allColumns.map((col, i) => (
                            <th key={i}>{formatHeader(col)}</th>
                        ))}
                    </tr>
                    </thead>

                    <tbody>
                    {data.map((row, i) => (
                        <tr key={i} onClick={() => handleRowClick(row)}>
                            {allColumns.map((col, j) => (
                                <td key={j}>{String(getValue(row, col))}</td>
                            ))}
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>

            <BaseModal isOpen={isModalOpen} onClose={handleCloseModal} title="Details">
                <div className="p-4">{clickedRow}</div>
            </BaseModal>
        </>
    );
};

export default SubmittedDataTable;
